import React, { ReactElement, useState } from 'react';
import Search from 'antd/lib/input/Search';
import { Form, FormInstance } from 'antd';

import { BreederRespError } from 'pricing/types';
import { testId } from 'pricing/utilities/test/dataTestId';
import { apiBreeder } from 'utilities/http/api/pricing/apiBreeder';
import { notify } from 'utilities/notifications/notify';

interface Props {
  form: FormInstance;
  disabled?: boolean;
}

function FieldContractSearchBreeder(props: Props): ReactElement {
  const { disabled, form } = props;
  const [loading, setLoading] = useState(false);

  const resetBreederNameField = () => {
    form.setFieldsValue({ breederName: '' });
    form.resetFields(['breederName']);
  };

  const getBreederInfo = async (value: string) => {
    if (!value) return;
    try {
      setLoading(true);
      const breederResp = await apiBreeder.getBreeder(Number(value));

      if (
        !breederResp.isOk &&
        breederResp.json?.errors?.value[0] === BreederRespError.InvalidBreederId
      ) {
        notify.error(`Breeder ID not found`);
        resetBreederNameField();
        form.validateFields(['breederId']);
        return;
      }

      const [user] = breederResp.json.breeder.users;
      const { firstName, lastName } = user;
      const breederName = `${firstName} ${lastName}`;

      form.setFieldsValue({ breederName });
      form.validateFields(['breederId']);
    } catch (e) {
      notify.error(`Couldn't identify breeder name`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Form.Item
      label="Breeder ID"
      name="breederId"
      rules={[{ required: true, message: 'This field is required to create contract' }]}
    >
      <Search
        type="number"
        data-testid={testId.fieldContractBreederId}
        loading={loading}
        autoComplete="off"
        onSearch={getBreederInfo}
        allowClear
        onChange={resetBreederNameField}
        disabled={disabled}
      />
    </Form.Item>
  );
}

export default FieldContractSearchBreeder;
